<template>

    <b-container fluid class="container-layout">
        <b-row align-h="center" class="">

            <p v-bind:style="{ 'color': color+'!important'}" class="title titulo-preguntas ">CARRERA:
                {{carrera | upper}}</p>


        </b-row>
        <b-row align-h="end">
            <b-col cols="3">
                <Timer :accept="accept" v-if="renderComponent" :endtime="limite" trans='{  
         "day":"Day",
         "hours":"Hours",
         "minutes":"Minuts",
         "seconds":"Seconds",
        "running":"Till the end of event.",
          "status": {
            "expired":"Expired",
            "running":"Running",
            "upcoming":"Future"
         }}'></Timer>
            </b-col>
        </b-row>
        <b-row align-h="center" class="mt-5">
            <b-col lg="10" md="9" sm="8">
                <p v-bind:style="{ 'color': color+'!important'}" class="contador-preguntas"> Pregunta
                    {{index+1}}/{{cantidaPreguntas}}</p>
            </b-col>
        </b-row>
        <b-row align-h="center" class="mt-2">
            <b-col lg="10" md="9" sm="8">
                <p v-html="preguntas[modulos[modulo].titulo][index].descripcion"></p>
            </b-col>
        </b-row>
        <b-row align-h="center" class="mt-1">
            <b-col lg="10" md="9" sm="8">
                <b-form-radio class="radios" style="cursor:pointer" @input="save()"
                    v-for="(items,key) in preguntas[modulos[modulo].titulo][index].opcion" :key="key"
                    v-model="respuestas[index]" name="some-radios" @change="saveAnswer(items)"
                    :value="{'modulo':preguntas[modulos[modulo].titulo][index].id_modulo, 'item':items }">
                    <p v-html="items.descripcion"></p>
                 
                </b-form-radio>
            </b-col>
        </b-row>
        <b-row align-h="start" class="ml-5 mt-4">
            <b-col cols="2" class="next">
                <svg v-bind:style="{ 'background-color': color+'!important'}" v-if="!primeraPregunta"   @click="back()"
                    style="cursor:pointer" height="20" width="20"></svg>
                <p v-if="!primeraPregunta" v-bind:style="{ 'color': color+'!important'}" class="back-svg">Anterior</p>

            </b-col>
            <b-col cols="8">

            </b-col>
            <b-col cols="2" class="back">
                <svg v-bind:style="{ 'background-color': color+'!important'}" v-if="!ultimaPregunta" @click="next()"
                    style="cursor:pointer" height="20" width="20"></svg>
                <p v-if="!ultimaPregunta" v-bind:style="{ 'color': color+'!important'}" class="next-svg">Siguiente</p>
            </b-col>
        </b-row>

        <b-row v-if="!ultimoModulo" align-h="center" class="mt-3 mb-5">
            <button @click="nextModulo()"
                v-bind:style="ultimaPregunta ? {'color':'white', 'background-color': color+'!important', 'border': '1px solid '+color+'!important' } : { 'color': color+'!important', 'border': '1px solid '+color+'!important' }"
                type="button" class="next-module">SIGUIENTE MÓDULO</button>
        </b-row>
        <b-row v-if="ultimoModulo" align-h="center" class="mt-3 mb-5">
            <button @click="terminarExamen()"
                v-bind:style="ultimaPregunta ? {'color':'white', 'background-color': color+'!important', 'border': '1px solid '+color+'!important' } : { 'color': color+'!important', 'border': '1px solid '+color+'!important' }"
                type="button" class="modulo-finish">TERMINAR EXAMEN</button>
        </b-row>

        <b-modal hide-footer ref="modal-2" hide-header-close centered size='lg'>
            <span class="animacion" v-html="instrucciones" />

            <b-row align-h="center">
                <button  @click="empezarModulo()" type="button" v-bind:style="{ 'background-color': color+'!important'}"
                    class="mt-3 modulo-intruccion">ACEPTAR</button>
            </b-row>
        </b-modal>

        <b-modal content-class="modal-finish" hide-footer ref="modal-resultado" hide-header-close centered size='md'>
            <b-row class="mt-1" align-h="center"><img src="@/assets/images/check.png" alt=""></b-row>
            <b-row align-h="center" class="mt-4 examen-finish">
                <p v-bind:style="{ 'color': color+'!important'}">TERMINAR EXAMEN</p>
            </b-row>
            <b-row align-h="center" class="mt-1 examen-finish2">
                <p> Aun le queda tiempo para poder continuar<br> ¿Estas seguro de terminar el Examen?</p>
            </b-row>

            <b-row align-h="center" class="mb-1 ml-1">
                <b-col lg="6">
                    <button @click="cancel()" v-bind:style="{ 'color': color+'!important'}"
                        class="modal-button-cancel">CANCELAR</button>
                </b-col>
                <b-col lg="6">
                    <button :disabled="isDisabled" @click="accept()" v-bind:style="{ 'background-color': color+'!important'}"
                        class="modal-button-accept">ACEPTAR</button>

                </b-col>
            </b-row>

        </b-modal>
        <b-modal content-class="modal-finish" hide-footer ref="modal-resultado-2" hide-header-close centered size='md'>
            <b-row class="mt-1" align-h="center"><img src="@/assets/images/check.png" alt=""></b-row>
            <b-row align-h="center" class="mt-3 examen-finish">
                <p v-bind:style="{ 'color': color+'!important'}">¿TERMINAR EXAMEN?</p>
            </b-row>
            <b-row align-h="center" class="examen-finish2">
                <p class="sub-simulacro">Aun faltan preguntas por responder de este módulo<br>¿Estas seguro de terminar el Examen?</p>
            </b-row>

            <b-row align-h="center" class=" ml-1">
                <b-col lg="6">
                    <button @click="cancel()" v-bind:style="{ 'color': color+'!important'}"
                        class="modal-button-cancel">CANCELAR</button>
                </b-col>
                <b-col lg="6">
                    <button :disabled="isDisabled" @click="accept()" v-bind:style="{ 'background-color': color+'!important'}"
                        class="modal-button-accept">ACEPTAR</button>

                </b-col>
            </b-row>

        </b-modal>
        <b-modal content-class="modal-finish" hide-footer ref="modal-modulo-2" hide-header-close centered size='md'>
            <b-row align-h="center"><img src="@/assets/images/check.png" alt=""></b-row>
            <b-row align-h="center" class="mt-4 examen-finish">
                <p v-bind:style="{ 'color': color+'!important'}">¿SIGUIENTE MÓDULO?</p>
            </b-row>
            <b-row align-h="center" class="mt-1 examen-finish2">
                <p class="sub-simulacro">Aun faltan preguntas por responder
                 <br><br>¿Desea continuar al siguiente módulo?</p>
            </b-row>

            <b-row align-h="center" class="ml-1">
                <b-col lg="6" class="">
                    <button v-bind:style="{ 'color': color+'!important'}" @click="cancelModulo()"
                        class="modal-button-cancel">CANCELAR</button>
                </b-col>
                <b-col lg="6" class="">
                    <button v-bind:style="{ 'background-color': color+'!important'}" :disabled="isDisabled" @click="acceptModulo()"
                        class="modal-button-accept">ACEPTAR</button>

                </b-col>
            </b-row>

        </b-modal>
        <b-modal content-class="modal-finish" hide-footer ref="modal-modulo" hide-header-close centered size='md'>
            <b-row align-h="center"><img src="@/assets/images/check.png" alt=""></b-row>
            <b-row align-h="center" class="mt-3 examen-finish">
                <p v-bind:style="{ 'color': color+'!important'}">Módulo {{this.modulo+1}} Terminado</p>
            </b-row>
            <b-row align-h="center" class="examen-finish2">
                <p class="sub-simulacro"> Aun le queda tiempo para poder
                    continuar <br> ¿Estas seguro de terminar el Módulo?
                   </p>
            </b-row>

            <b-row align-h="center" class="mb-2 ml-1">
                <b-col lg="6" class="mt-2">
                    <button v-bind:style="{ 'color': color+'!important'}"  @click="cancelModulo()"
                        class="modal-button-cancel">CANCELAR</button>
                </b-col>
                <b-col lg="6" class="mt-2">
                    <button v-bind:style="{ 'background-color': color+'!important'}" :disabled="isDisabled"  @click="acceptModulo()"
                        class="modal-button-accept">ACEPTAR</button>

                </b-col>
            </b-row>

        </b-modal>
        <b-modal content-class="modal-finish-ter" hide-footer ref="modal-ter-1" hide-header-close centered size='md'>
            <b-row align-h="center"><img src="@/assets/images/education1.png" alt=""></b-row>
            <b-row align-h="center" class="mt-4 examen-finish">
                <b-col cols="10">
                    <p style="text-align:center;color:#0F376E">FELICIDADES {{nombre}}</p>
                </b-col>
            </b-row>
            <b-row align-h="center" class="mt-1 examen-finish2">
                <b-col cols="12">
                    <p>Has completado tu examen de simulacro.<br>GRACIAS</p>
                </b-col>
            </b-row>

            <b-row align-h="center" class="mb-2 ml-1">
                <button @click="finish()" class="modal-button-accept-finish">ACEPTAR</button>

            </b-row>

        </b-modal>
         <semipolar-spinner
    v-if="loaded"
    class="spinner"
  :animation-duration="2000"
  :size="80"
  color="#0F376E"
/>
    </b-container>
</template>
<script>
    /*import {
        Swiper,
        SwiperSlide
    } from 'vue-awesome-swiper'
    */
   import { SemipolarSpinner  } from 'epic-spinners'

    import 'swiper/css/swiper.css'
    import Timer from '@/components/Student/Timer'
    import moment from 'moment'

    export default {
        name: 'Simulacro',
        components: {
            Timer,
            SemipolarSpinner
            /* Swiper,
            SwiperSlide
        */
        },
        props: {
            tipo: {
                type: String
            }
        },
        data: () => ({
            isDisabled:false,
            instrucciones:'',
            swiperOption: {
                effect: "fade",
                speed: 1000,

                fadeEffect: {
                    crossFade: true
                },
                slidesPerView: 1,
                pagination: {
                    el: '.swiper-pagination',
                    dynamicBullets: true
                },
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false
                }
            },
            renderComponent: true,
            simulacros: '',
            limite: '',
            preguntas: [],
            carrera: '',
            intruccionesmodulo: '',
            animacionesresultados: '',
            cantidaPreguntas: null,
            index: 0,
            moduloactual: [],
            moduloinstr:[],
            modulo: 0,
            color: '',
            modulos: [],
            nombre: '',
            respuestas: [],
            id_estudiante:[],
            loaded:false,
        }),
        created() {
            this.id_estudiante = localStorage.getItem('id_estudiante');
            console.log("aqui JSON",  JSON.parse(localStorage.getItem('respuestas')));

            this.respuestas = JSON.parse(localStorage.getItem('respuestas')) ? JSON.parse(localStorage.getItem(
                'respuestas')) : this.respuestas
            this.nombre = JSON.parse(localStorage.getItem('estudiante'))
            this.nombre = this.nombre.nombre
            this.index = localStorage.getItem('index') ? parseInt(localStorage.getItem('index')) : parseInt(this.index)
            this.modulo = localStorage.getItem('modulo') ? parseInt(localStorage.getItem('modulo')) : parseInt(this
                .modulo)
            this.limite = localStorage.getItem('limite') ? new Date(localStorage.getItem('limite')) : this.limite
            JSON.parse(localStorage.getItem('estudiante'))
            this.carrera = localStorage.getItem('carrera')
            this.getPreguntas()
            this.getAnimacionesResultados()
            this.getOption()
            console.log(this.intruccionesmodulo)


        },
        methods: {
            getOption(){
               /* console.log()
                if(this.respuestas.length==0){
                    /* this.respuestas[0]= {
                                item: {
                                    correcta:0,
                                    descripcion:"1/2",
                                    id_opcion:1,
                                    id_pregunta:85,
                                    letra:"A",
                                },
                               id_modulo: 4
                            }*/
               /* this.$store.dispatch('getOption', this.id_estudiante)
                    .then((response) => {
                         console.log("aqui element", response)
                        /*response.data.opcion.forEach((element, index) => {
                            console.log("aqui element", element + index)
                            let modulo  = element.id_modulo 
                            delete element.id 
                            delete element.id_estudiante 
                            delete element.id_modulo 
                            delete element.titulo 
                            this.respuestas[index]= {
                             
                                id_modulo: modulo,
                                   item: element,
                            }

                 });
                        */                            
       
                     //this.respuestas =  response.data.opcion 
               /* })
       }*/
       },
            saveAnswer(){
                
               /* let data = {
                    id_opcion: value.id_opcion,
                    id_pregunta: value.id_pregunta,
                    id_estudiante: this.id_estudiante,
                    index: this.index
                 }
                  this.$store.dispatch('postOption', data)
                    .then((response) => {
                     console.log(response.data)
                    })*/
            },
            finish() {
                this.$router.push('Verificar-datos')
            },
            cancel() {
                if (this.ultimaPregunta) {
                    this.$refs['modal-resultado'].hide()
                } else {
                    this.$refs['modal-resultado-2'].hide()
                }
            },
            accept() {
                this.loaded=true
                this.isDisabled=true
                for (let index = 0; index < this.cantidaPreguntas; index++) {
                    if (!this.respuestas[index]) {
                        if (index == 0) {
                             this.respuestas[index] = {'modulo': this.moduloactual[0].id_modulo}
                        } else {
                            this.respuestas[index] = null
                        }
                    }

                }


                var existing = JSON.parse(localStorage.getItem('respuestasAll')) ? JSON.parse(localStorage.getItem(
                    'respuestasAll')) : []
                existing.push(this.respuestas)
                localStorage.setItem('respuestasAll', JSON.stringify(existing))
                localStorage.removeItem('respuestas');
                localStorage.removeItem('index');
                localStorage.removeItem('modulo');
                localStorage.removeItem('limite');
                this.$refs['modal-resultado'].hide()
                let data = {
                    'respuestas': JSON.parse(localStorage.getItem('respuestasAll')),
                    'estudiante': JSON.parse(localStorage.getItem('estudiante'))
                }
                this.$store.dispatch('postRespuestas', data)
                    .then((response) => {
                        console.log(response.data)
                        this.$store.dispatch('setColor', '#0F376E')

                        this.$store.dispatch('setModulo', 'Validacion de datos')
                   
                        this.$refs['modal-ter-1'].show()
                        this.disabled=false
                        this.loaded=false
                    })
        this.disabled=false
        this.loaded=false
            },
            terminarExamen() {
                if (this.ultimaPregunta) {
                    this.$refs['modal-resultado'].show()
                } else {
                    this.$refs['modal-resultado-2'].show()
                }
            },
            empezarModulo() {
                this.$refs['modal-2'].hide()
                let ultimo = this.modulo == this.modulos.length - 1 ? true : false
                localStorage.setItem("ultimo_modulo", ultimo)

            },
            verificcarUltimo2() {
                if (this.swiper2.isEnd) {
                    this.swiper2.autoplay.stop()
                }
            },
            cancelModulo() {
                if (this.ultimaPregunta) {
                    this.$refs['modal-modulo'].hide()
                } else {
                    this.$refs['modal-modulo-2'].hide()
                }

            },
            nextModulo() {
                if (this.ultimaPregunta) {
                    this.$refs['modal-modulo'].show()
                } else {
                    this.$refs['modal-modulo-2'].show()
                }
            },
            acceptModulo() {
                  this.loaded=true
                    this.disabled=true
                if (this.ultimaPregunta) {
                    this.$refs['modal-modulo'].hide()
                } else {
                    this.$refs['modal-modulo-2'].hide()
                }
                for (let index = 0; index < this.cantidaPreguntas; index++) {
                        if (!this.respuestas[index]) {
                        if (index == 0) {
                            this.respuestas[index] = {'modulo': this.moduloactual[0].id_modulo}
                        } else {
                            this.respuestas[index] = null
                        }
                    }

                }



                var existing = JSON.parse(localStorage.getItem('respuestasAll')) ? JSON.parse(localStorage.getItem(
                    'respuestasAll')) : []
                existing.push(this.respuestas)
                localStorage.setItem('respuestasAll', JSON.stringify(existing))
                localStorage.removeItem('respuestas');
                localStorage.removeItem('index');
                this.respuestas = []
                this.modulo = parseInt(this.modulo) + 1
                this.color = this.modulos[this.modulo].color
                localStorage.setItem('color', this.color)
                localStorage.setItem('modulo', this.modulo)
                localStorage.setItem('nombre_modulo', this.modulos[this.modulo].titulo)
                this.$store.dispatch('setColor', this.color)
                this.$store.dispatch('setModulo', this.modulos[this.modulo].titulo)


                this.moduloactual = this.preguntas[this.modulos[this.modulo].titulo]
                this.cantidaPreguntas = this.moduloactual.length
                this.index = 0
                this.limite = moment(moment()).add(this.modulos[this.modulo].tiempo, 'm').toDate();
                localStorage.setItem('limite', this.limite)
                  this.loaded=false
                  this.disabled=false
                 this.instrucciones= this.intruccionesmodulo[this.modulo].instruccion
                this.$refs['modal-2'].show()
                this.renderComponent = false;
                this.$nextTick(() => {
                    this.renderComponent = true;
                });
            },
            save()
             {
                // console.log("aqui respuesta",this.respuestas)
                localStorage.setItem('respuestas', JSON.stringify(this.respuestas))

            },
            next() {
                localStorage.setItem("ultimo_modulo", this.ultimoModulo)

                let pregunta = this.preguntas[this.modulos[this.modulo].titulo][this.index].id_pregunta  
                   console.log(pregunta)
                let data = {
                    id_opcion: this.respuestas[this.index] ? this.respuestas[this.index].item.id_opcion : '',
                    id_pregunta: pregunta,
                    id_estudiante: this.id_estudiante
                 }
                  this.$store.dispatch('postOption', data)
                    .then((response) => {
                      console.log("response", response)
                    })
                //console.log("aqui respuesta",this.respuestas[this.index])
                localStorage.setItem('index', this.index)
                localStorage.setItem('modulo', this.modulo)
                this.index = parseInt(this.index) + 1

            },
            back() {
                this.index = this.index - 1
                localStorage.setItem('respuestas', JSON.stringify(this.respuestas))
                localStorage.setItem('index', this.index)
                localStorage.setItem('modulo', this.modulo)
            },
         
            getPreguntas() {
                   let data = {
                id:localStorage.getItem('id_simulacro'),
                id_carrera:localStorage.getItem('id_carrera'),
            }
                this.$store.dispatch('getPregunta', data)
                    .then((response) => {
                        this.preguntas = response.data.preguntas
                        this.modulos = response.data.modulos
                        this.getInstruccionesModulos()
                        this.color = this.modulos[this.modulo].color
                        this.$store.dispatch('setColor', this.color)
                        this.$store.dispatch('setModulo', this.modulos[this.modulo].titulo)
                        if (!localStorage.getItem('color')) {
                            localStorage.setItem('color', this.color)
                        }
                        if (!localStorage.getItem('nombre_modulo')) {
                            localStorage.setItem('nombre_modulo', this.modulos[this.modulo].titulo)
                        }
                        this.moduloactual = this.preguntas[this.modulos[this.modulo].titulo]
                        if (!localStorage.getItem('limite')) {
                            //console.log("asdasdasdasdas as dasd asdas as")
                            this.limite = moment(moment()).add(this.modulos[this.modulo].tiempo, 'm').toDate();
                            //this.limite= moment(moment()).add(5, 's').toDate();
                            localStorage.setItem('limite', this.limite)
                        }
                        this.cantidaPreguntas = this.moduloactual.length
                    })
                    .catch((error) => {
                        console.log(error.message)
                    })
            },
            getInstruccionesModulos() {
                for (let index = 0; index < this.modulos.length; index++) {
                    this.moduloinstr.push(this.modulos[index].id_modulo);
                }
                
                let  data  = {
                    ids_modulos:this.moduloinstr
                }
                this.$store.dispatch('getInstruccionesModuloExamen', data)
                    .then((response) => {   
                        this.intruccionesmodulo = response.data.instruccion
                                    this.instrucciones= this.intruccionesmodulo[this.modulo].instruccion
                                    this.$refs['modal-2'].show()
    

                    })
                    .catch((error) => {
                        console.log(error.message)
                    })

            },
            getAnimacionesResultados() {
                this.$store.dispatch('getAnimacionesResultados', localStorage.getItem('id_simulacro'))
                    .then((response) => {
                        this.animacionesresultados = response.data.animacion

                    })
                    .catch((error) => {
                        console.log(error.message)
                    })

            }

        },
        computed: {
            ultimoModulo() {
                return this.modulo == this.modulos.length - 1 ? true : false
            },
            primeraPregunta() {
                return this.index == 0 ? true : false
            },
            ultimaPregunta() {
                return this.index == this.moduloactual.length - 1 ? true : false
            },
            swiper2() {
                return this.$refs.swiper2.$swiper
            }
            /*tituloModulo() {
                console
                if(this.respuestas[this.index].length<this.preguntas[this.modulos[this.modulo].length])
                return true
                else{
                return false
                }
            }*/


        },
        filters: {
            upper: function (value) {
                return value.toUpperCase()
            }
        }
    }
</script>